export enum DlNavigationQA {
    SearchInput = 'dl-nav-search-input',
    Row = 'dl-nav-row',
    NavigationMinimal = 'navigation-minimal',
    MinimalDoneBtn = 'navigation-mininal-done-btn',
    AsideMenuItem = 'aside-nav-menu-item',
    List = 'navigation-list',
    NavigationBreadcrumbs = 'dl-navigation-breadcrumbs',
}
